"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const SuperStoreWorker = require("worker-loader!./superstore-worker");
const PromiseWorker = require("promise-worker");
class WorkerStoreService {
    constructor(fetcher) {
        this.observers = new Map();
        this.paramUris = new Map();
        this.worker = new PromiseWorker(new SuperStoreWorker()); //new Worker(workerPath);
        this.worker._worker.addEventListener('message', this.notifyObservers.bind(this));
        if (fetcher) {
            //TODO doesn't work of course..
            this.worker.postMessage({ function: 'setFetcher', args: [fetcher] });
        }
    }
    ////// CONSTRAINT FUNCTIONS ///////
    addConstraint(ownerUri, constraint) {
        return this.worker.postMessage({ function: 'addConstraint', args: [ownerUri, constraint] });
    }
    addVariable(variable) {
        return this.worker.postMessage({ function: 'addVariable', args: [variable] });
    }
    activateNewConstraints(constraintUris) {
        return this.worker.postMessage({ function: 'activateNewConstraints', args: [constraintUris] });
    }
    deactivateConstraints(constraintUris) {
        return this.worker.postMessage({ function: 'deactivateConstraints', args: [constraintUris] });
    }
    ////// DYMOSTORE FUNCTIONS ////////
    loadOntologies(localPath) {
        return this.worker.postMessage({ function: 'loadOntologies', args: [localPath] });
    }
    addBasePath(dymoUri, path) {
        return this.worker.postMessage({ function: 'addBasePath', args: [dymoUri, path] });
    }
    addParameterObserver(dymoUri, parameterType, observer) {
        return __awaiter(this, void 0, void 0, function* () {
            const paramUri = yield this.worker.postMessage({ function: 'addParameterObserver', args: [dymoUri, parameterType, null] });
            this.paramUris.set(dymoUri + parameterType, paramUri);
            this.addObserver(observer, paramUri);
            return paramUri;
        });
    }
    removeParameterObserver(dymoUri, parameterType, observer) {
        return __awaiter(this, void 0, void 0, function* () {
            const paramUri = this.paramUris.get(dymoUri + parameterType);
            if (this.removeObserver(observer, paramUri)) {
                //none left for this paramUri
                yield this.worker.postMessage({ function: 'removeParameterObserver', args: [dymoUri, parameterType, null] });
            }
            return paramUri;
        });
    }
    addPartsObserver(dymoUri, observer) {
        this.addObserver(observer, dymoUri);
        return this.worker.postMessage({ function: 'addPartsObserver', args: [dymoUri, null] });
    }
    removePartsObserver(dymoUri, observer) {
        if (this.removeObserver(observer, dymoUri)) {
            //none left for this dymoUri
            return this.worker.postMessage({ function: 'removePartsObserver', args: [dymoUri, null] });
        }
    }
    addRendering(renderingUri, dymoUri) {
        return this.worker.postMessage({ function: 'addRendering', args: [renderingUri, dymoUri] });
    }
    addDymo(dymoUri, parentUri, partUri, sourcePath, type) {
        return this.worker.postMessage({ function: 'addDymo', args: [dymoUri, parentUri, partUri, sourcePath, type] });
    }
    findTopDymos() {
        return this.worker.postMessage({ function: 'findTopDymos', args: [] });
    }
    findAllObjectsInHierarchy(dymoUri) {
        return this.worker.postMessage({ function: 'findAllObjectsInHierarchy', args: [dymoUri] });
    }
    addPart(dymoUri, partUri) {
        return this.worker.postMessage({ function: 'addPart', args: [dymoUri, partUri] });
    }
    insertPartAt(dymoUri, partUri, index) {
        return this.worker.postMessage({ function: 'insertPartAt', args: [dymoUri, partUri, index] });
    }
    removeParts(dymoUri, index) {
        return this.worker.postMessage({ function: 'removeParts', args: [dymoUri, index] });
    }
    findParts(dymoUri) {
        return this.worker.postMessage({ function: 'findParts', args: [dymoUri] });
    }
    findPartAt(dymoUri, index) {
        return this.worker.postMessage({ function: 'findPartAt', args: [dymoUri, index] });
    }
    findAllParents(dymoUri) {
        return this.worker.postMessage({ function: 'findAllParents', args: [dymoUri] });
    }
    getAllSourcePaths() {
        return this.worker.postMessage({ function: 'getAllSourcePaths', args: [] });
    }
    getSourcePath(dymoUri) {
        return this.worker.postMessage({ function: 'getSourcePath', args: [dymoUri] });
    }
    addControl(name, type, uri) {
        return this.worker.postMessage({ function: 'addControl', args: [name, type, uri] });
    }
    setParameter(ownerUri, parameterType, value) {
        return this.worker.postMessage({ function: 'setParameter', args: [ownerUri, parameterType, value] });
    }
    findParameterValue(ownerUri, parameterType) {
        return this.worker.postMessage({ function: 'findParameterValue', args: [ownerUri, parameterType] });
    }
    addCustomParameter(ownerUri, paramType) {
        return this.worker.postMessage({ function: 'addCustomParameter', args: [ownerUri, paramType] });
    }
    setFeature(ownerUri, featureType, value) {
        return this.worker.postMessage({ function: 'setFeature', args: [ownerUri, featureType, value] });
    }
    findFeatureValue(ownerUri, featureType) {
        return this.worker.postMessage({ function: 'findFeatureValue', args: [ownerUri, featureType] });
    }
    findAttributeValue(ownerUri, attributeType) {
        return this.worker.postMessage({ function: 'findAttributeValue', args: [ownerUri, attributeType] });
    }
    setControlParam(controlUri, parameterType, value) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.worker.postMessage({ function: 'setControlParam', args: [controlUri, parameterType, value] });
        });
    }
    findControlParamValue(controlUri, parameterType) {
        return this.worker.postMessage({ function: 'findControlParamValue', args: [controlUri, parameterType] });
    }
    addNavigator(renderingUri, navigatorType, variableUri) {
        return this.worker.postMessage({ function: 'addNavigator', args: [renderingUri, navigatorType, variableUri] });
    }
    getAttributeInfo() {
        return this.worker.postMessage({ function: 'getAttributeInfo', args: [] });
    }
    findMaxLevel(dymoUri) {
        return this.worker.postMessage({ function: 'findMaxLevel', args: [dymoUri] });
    }
    toJsonGraph(nodeClass, edgeProperty, previousGraph) {
        return this.worker.postMessage({ function: 'toJsonGraph',
            args: [nodeClass, edgeProperty, previousGraph] });
    }
    uriToJsonld(frameUri) {
        return this.worker.postMessage({ function: 'uriToJsonld', args: [frameUri] });
    }
    ////// EASYSTORE FUNCTIONS /////////
    addValueObserver(subject, predicate, observer) {
        this.addObserver(observer, subject);
        return this.worker.postMessage({ function: 'addValueObserver', args: [subject, predicate, null] });
    }
    addTypeObserver(type, observer) {
        this.addObserver(observer, type);
        return this.worker.postMessage({ function: 'addTypeObserver', args: [type, null] });
    }
    getValueObserverCount() {
        return this.worker.postMessage({ function: 'getValueObserverCount', args: [] });
    }
    size() {
        return this.worker.postMessage({ function: 'size', args: [] });
    }
    setValue(subject, predicate, value) {
        return this.worker.postMessage({ function: 'setValue', args: [subject, predicate, value] });
    }
    findSubject(predicate, object) {
        return this.worker.postMessage({ function: 'findSubject', args: [predicate, object] });
    }
    findSubjects(predicate, object) {
        return this.worker.postMessage({ function: 'findSubjects', args: [predicate, object] });
    }
    findObject(subject, predicate) {
        return this.worker.postMessage({ function: 'findObject', args: [subject, predicate] });
    }
    findAllObjects(subject, predicate) {
        return this.worker.postMessage({ function: 'findAllObjects', args: [subject, predicate] });
    }
    findObjectValue(subject, predicate) {
        return this.worker.postMessage({ function: 'findObjectValue', args: [subject, predicate] });
    }
    findAllObjectValues(subject, predicate) {
        return this.worker.postMessage({ function: 'findAllObjectValues', args: [subject, predicate] });
    }
    isSubclassOf(class1, class2) {
        return this.worker.postMessage({ function: 'isSubclassOf', args: [class1, class2] });
    }
    recursiveFindAllSubClasses(superclassUri) {
        return this.worker.postMessage({ function: 'recursiveFindAllSubClasses', args: [superclassUri] });
    }
    addTriple(subject, predicate, object) {
        return this.worker.postMessage({ function: 'addTriple', args: [subject, predicate, object] });
    }
    loadData(data) {
        return this.worker.postMessage({ function: 'loadData', args: [data] });
    }
    logData() {
        return this.worker.postMessage({ function: 'logData', args: [] });
    }
    ////// PRIVATE FUNCTIONS
    addObserver(observer, uriOrType) {
        if (!this.observers.has(uriOrType)) {
            this.observers.set(uriOrType, []);
        }
        this.observers.get(uriOrType).push(observer);
    }
    /** returns true if it was the last observer for the given uriOrType */
    removeObserver(observer, uriOrType) {
        const observers = this.observers.get(uriOrType);
        if (observers) {
            observers.splice(observers.indexOf(observer), 1);
            if (observers.length == 0) {
                this.observers.delete(uriOrType);
                return true;
            }
        }
    }
    notifyObservers(event) {
        if (event.data.paramUri) {
            const observers = this.getObservers(event.data.paramUri)
                .concat(this.getObservers(event.data.paramType));
            observers.forEach(o => o.observedValueChanged(event.data.paramUri, event.data.paramType, event.data.value));
        }
        else if (event.data.dymoUri) {
            const observers = this.getObservers(event.data.dymoUri);
            observers.forEach(o => o.observedPartsChanged(event.data.dymoUri));
        }
    }
    getObservers(uriOrType) {
        const observers = this.observers.get(uriOrType);
        return observers ? observers : [];
    }
}
exports.WorkerStoreService = WorkerStoreService;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-player/lib/worker-store/superstore-service.js
// module id = 1318
// module chunks = 3